import React, { useState } from "react";

const Filters = () => {
  const [open,setOpen] = useState(window.innerWidth > 992 ? true : false);
  return (
    <div className="shadow">
      <div onClick={()=>setOpen(o=>!o)} className={`hide_on_large border border-left-0 border-right-0 border-dark px-3 py-4 bg-light ${open ? "check" : ""}`}>
        <h6 className="d-inline-block text-uppercase mb-0">Apply Search Filters</h6>  <div className="float-right">
          <svg xmlns="http://www.w3.org/2000/svg" style={{transform: `rotate(${open ? 180 : 0}deg)`,transition: "all 0.3s"}} width={24} height={24} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.59 8.59003L12 13.17L7.41 8.59003L6 10L12 16L18 10L16.59 8.59003Z" fill="black" fillOpacity="0.38" />
          </svg>
        </div>
      </div>
      {open ? <div>
      <div className="bg-white">
        <div className="container">
          <div className="row py-lg-4 py-3">
            <div className="col-lg-3 switch_button pl-lg-5">
              <label className="w-100">
                <input type="checkbox" />
                <span className="lever hide_on_med"></span>
                Video Consultation
                <span className="lever float-right hide_on_large"></span>
              </label>
            </div>
            <div className="form_input col-lg-2 hide_on_med">
              <select
                name="time"
                defaultValue="disabled"
                className="form-control px-3 py-2 h-auto"
              >
                <option value="disabled" disabled>
                  Availability
                </option>
                <option value="volvo">Volvo</option>
                <option value="saab">Saab</option>
                <option value="opel">Opel</option>
                <option value="audi">Audi</option>
              </select>
            </div>
            <div className="form_input col-lg-2 hide_on_med">
              <select
                name="time"
                defaultValue="disabled"
                className="form-control  px-3 py-2 h-auto"
              >
                <option value="disabled" disabled>
                  All Filters
                </option>
                <option value="volvo">Volvo</option>
                <option value="saab">Saab</option>
                <option value="opel">Opel</option>
                <option value="audi">Audi</option>
              </select>
            </div>
            <div className="col-lg-5">
              <div className="row">
                <div className="col-lg-3 hide_on_med text-right d-flex justify-content-end align-items-center">
                  <label
                    htmlFor="sort"
                    className="d-inline-block  font-weight-bold"
                  >
                    Sort By:
                  </label>
                </div>
                <div className=" col-lg-6">
                  <select
                    defaultValue="disabled"
                    name="sort"
                    id="sort"
                    className="form-control hide_on_med px-3 py-2 h-auto"
                  >
                    <option value="disabled" disabled>
                      Relevance
                    </option>
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="opel">Opel</option>
                    <option value="audi">Audi</option>
                  </select>
                  <div className="hide_on_large pt-3">
                    <h6 className="font-weight-bold">Availability</h6>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="td"
                          name="avail"
                        />
                        <label htmlFor="td" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Today</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="tm"
                          name="avail"
                        />
                        <label htmlFor="tm" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Tomarrow</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="n7d"
                          name="avail"
                        />
                        <label htmlFor="n7d" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>In next 7 days</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: `#F2F2F2` }} className="bg-sm-white">
        <div className="container">
          <div className="row py-4">
            <div className="col-lg-3 h3desc">
              <div className="row">
                <div className="font-weight-bold col-lg-4 py-2">Gender: </div>
                <div className="d-inline-flex justify-content-center px-2 col-lg-4 col-6 text-center py-2">
                  <input type="checkbox" hidden id="male" />
                  <label htmlFor="male" className="checkbox"></label>
                  <label htmlFor="male" className="h3desc">
                    Male
                  </label>
                </div>
                <div className="d-inline-flex justify-content-center px-2 col-lg-4 col-6 text-center py-2">
                  <input type="checkbox" hidden id="female" />
                  <label htmlFor="female" className="checkbox"></label>
                  <label htmlFor="female" className="h3desc">
                    Female
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-9 h3desc">
              <div className="row">
                <div className="col-lg-3 pl-lg-5 py-2">
                  <b>Consultation Fee:</b>
                </div>
                <div className="col-lg-2 col-6 py-lg-2 py-3 d-lg-block d-flex justify-content-center align-items-center">
                  <div className="form__radio-group w-auto ">
                    <input
                      type="radio"
                      className="form__radio-input"
                      id="free"
                      name="price"
                    />
                    <label htmlFor="free" className="form__radio-label h3desc">
                      <span className="form__radio-botton"></span>
                      <span>Free</span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-6 py-lg-2 py-3 d-lg-block d-flex justify-content-center align-items-center">
                  <div className="form__radio-group w-auto ">
                    <input
                      type="radio"
                      className="form__radio-input"
                      id="p200"
                      name="price"
                    />
                    <label htmlFor="p200" className="form__radio-label h3desc">
                      <span className="form__radio-botton"></span>
                      <span>1-200</span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-6 py-lg-2 py-3 d-lg-block d-flex justify-content-center align-items-center">
                  <div className="form__radio-group w-auto ">
                    <input
                      type="radio"
                      className="form__radio-input"
                      id="p2-500"
                      name="price"
                    />
                    <label
                      htmlFor="p2-500"
                      className="form__radio-label h3desc"
                    >
                      <span className="form__radio-botton"></span>
                      <span>201-500</span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-6 py-lg-2 py-3 d-lg-block d-flex justify-content-center align-items-center">
                  <div className="form__radio-group w-auto ">
                    <input
                      type="radio"
                      className="form__radio-input"
                      id="p500"
                      name="price"
                    />
                    <label htmlFor="p500" className="form__radio-label h3desc">
                      <span className="form__radio-botton"></span>
                      <span>500+</span>
                    </label>
                  </div>
                </div>
                <div className="py-3 hide_on_large container-fluid">
                <div>
                    <h6 className="font-weight-bold">Sort by:</h6>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="Relevance"
                          name="sort"
                        />
                        <label htmlFor="Relevance" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Relevance</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="Earliest"
                          name="sort"
                        />
                        <label htmlFor="Earliest" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Earliest Available</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="Price"
                          name="sort"
                        />
                        <label htmlFor="Price" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Price - Low to High</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="low"
                          name="sort"
                        />
                        <label htmlFor="low" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Price - High to Low</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="high"
                          name="sort"
                        />
                        <label htmlFor="high" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Price - High to Low</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="years"
                          name="sort"
                        />
                        <label htmlFor="years" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Years of Experience</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12 py-3">
                      <div className="form__radio-group w-auto ">
                        <input
                          type="radio"
                          className="form__radio-input"
                          id="Recommendation"
                          name="sort"
                        />
                        <label htmlFor="Recommendation" className="form__radio-label h3desc">
                          <span className="form__radio-botton"></span>
                          <span>Recommendation</span>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row pt-2">
                        <div className="col-6 text-uppercase d-flex justify-content-center align-items-center">
                          <button className="bg-white border-0">Clear All</button>
                        </div>
                        <button className="col-6 tableButton text-uppercase active text-center py-2">Show Doctors</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div> : ""}
    </div>
  );
};

export default Filters;
